import Vue from 'vue';
import locale from 'element-ui/lib/locale';
import VueI18n from 'vue-i18n';
import messages from './lang';

Vue.use(VueI18n);

/* Object.entries(messages).forEach((item, index) => {
    console.log(item[0] + ' = ' + JSON.stringify(item[1]));
}); */

const i18n = new VueI18n({
    locale: process.env.VUE_APP_I18N_LOCALE || 'cn',
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
    messages: messages
});

//为了实现element插件的多语言切换
locale.i18n((key, value) => i18n.t(key, value));

export default i18n;